import * as types from './mutation-types'

export const mutations = {
  [types.SET_DEVICE](state, device) {
    state.device = device
  },
  [types.SET_GEO_POSITION](state, position) {
    state.geoPosition = position
  },  
  [types.SET_RESERVATION_DATE](state, date) {
    state.reservationDate = date
  },
  [types.SET_RESERVATION_DATE_FOR_SERVER](state, date) {
    state.reservationDateForServer = date
  },
  [types.SHOW_LOADER](state) {
    setTimeout(() => {
      state.loader = false
    }, 3000)
    state.loader = true
  },
}



//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/global/mutations.js
// module id = null
// module chunks = 